<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="userData.login"
          type="email"
          append-icon="email"
          :rules="[rules.required, rules.regex]"
          :label="$t('profile.sections.user.login')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="pt-0"
      >
        <v-text-field
          v-model="userData.password"
          :append-icon="show ? 'visibility' : 'visibility_off'"
          :type="show ? 'text' : 'password'"
          :label="$t('profile.sections.user.password-edit')"
          :hint="$t('field.min-8')"
          counter
          @click:append="show = !show"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="userData.name"
          :rules="[rules.required]"
          :label="$t('profile.sections.common.name')"
          dense
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="userData.firstname"
          :rules="[rules.required]"
          :label="$t('profile.sections.user.firstname')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="userData.phone"
          :label="$t('profile.sections.user.phone')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="userData.access"
          :items="accessesData"
          :label="$t('profile.sections.user.access')"
          disabled
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn
          color="success"
          :disabled="userData.login.length < 6 || disableButton"
          @click="checkBeforeUpdate()"
        >
          <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileAccessConnector } from "../Database/ProfileAccessConnector.js";
import { ProfileUserConnector } from "../Database/ProfileUserConnector.js";
import { PlayerConnector } from "../Database/PlayerConnector.js";

export default {
  components: {},
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      playerConnector: new PlayerConnector(this.$store.state.user),
      show: false,
      userData: {
        login: "",
        password: "",
        name: "",
        firstname: "",
        phone: "",
        access: "",
        players: "",
      },
      pAccess: [],
      accessesData: [],
      disableButton: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getListAccess();
      this.getUserData();
      this.getAllPlayers();
    }
  },
  methods: {
    //Liste de players non modifiable mais nécessaire pour la requête update
    getAllPlayers() {
      this.playerConnector
        .getAllPlayersIdName()
        .then((players) => {
          this.players = players;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getListAccess() {
      this.accessConnector.getListAccess().then((accesses) => {
        // TODO: format in db server
        this.accessesData = accesses.map((data) => {
          return {
            value: data.id_right,
            text: data.name,
          };
        });
      });
    },
    getUserData() {
      this.userConnector.getUserData().then((user) => {
        let pAccess = [];
        if (user[0].players !== null) {
          pAccess = user[0].players.split("|").map((player) => {
            return parseInt(player);
          });
        }
        if (user.length > 0) {
          this.userData = {
            login: user[0].login,
            password: "",
            name: user[0].lastname,
            firstname: user[0].firstname,
            phone: user[0].phone,
            access: user[0].right_id,
            players: pAccess,
            dir: user[0].dir,
          };
        }
      });
    },

    //Vérifie le contenu du champ de mot de passe avant d'effetuer ou non la requete update
    checkBeforeUpdate() {
      if (this.userData.players == null) {
        this.userData.players = "";
      }
      if (this.userData.password.length == 0) {
        this.updateConnectedUserDataWithoutPassword(this.$store.state.user.uid);
      } else if (this.userData.password.length < 8 && this.userData.password.length >= 1) {
        this.$store.dispatch("openSnackbar", {
          txt: this.$t("error.incomplete-password"),
          colorBg: "orange",
        });
      } else {
        this.updateConnectedUserData(this.$store.state.user.uid);
      }
    },

    updateConnectedUserData(uid) {
      if (this.userData.login.length >= 6 && this.userData.password.length >= 8) {
        this.disableButton = true;
        this.userConnector
          .updateUserData(this.userData, uid)
          .then(() => {
            this.userData.password = "";

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.update-current-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },

    updateConnectedUserDataWithoutPassword(uid) {
      if (this.userData.login.length >= 6) {
        this.disableButton = true;
        this.userConnector
          .updateUserDataWithoutPassword(this.userData, uid)
          .then(() => {
            this.userData.password = "";

            this.$store.dispatch("openSnackbar", {
              txt: this.$t("dialog.update-current-user"),
              colorBg: "green",
            });
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
  },
};
</script>

<style></style>
